module.exports = __webpack_public_path__ + "img/0e20109.jpg";